require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-dj-schwa-sash.json") })
        }
      }, "path---interview-dj-schwa-sash");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-dj-schwa-sash!./.cache/json/interview-dj-schwa-sash.json
// module id = 668
// module chunks = 231608221292675